// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label[data-v-f83b930a]{padding-inline-end:12px}`, "",{"version":3,"sources":["webpack://./src/components/EditorSettings.vue"],"names":[],"mappings":"AAEA,uBACC,uBAAA","sourcesContent":["\n\nlabel {\n\tpadding-inline-end: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
